import { render, staticRenderFns } from "./AccountReceivableReceipt.vue?vue&type=template&id=09b84ed6"
import script from "./AccountReceivableReceipt.vue?vue&type=script&lang=js"
export * from "./AccountReceivableReceipt.vue?vue&type=script&lang=js"
import style0 from "./AccountReceivableReceipt.vue?vue&type=style&index=0&id=09b84ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports